import { Component } from '@angular/core';
import {
  BaseComponent
} from 'base-form';

@Component({
  selector: 'mfpc-arr-smart-show-mode',
  templateUrl: './arr-smart-show-mode.component.html',
  styleUrls: ['./arr-smart-show-mode.component.scss'],
})
export class ArrSmartShowModeComponent extends BaseComponent {}
